import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReceiptModel } from 'src/app/shared/model/receipt.model';
import { DonorCrmService } from 'src/app/shared/services/donor-crm/donor-crm.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
@Component({
  selector: 'app-donor-crm-info',
  templateUrl: './donor-crm-info.component.html',
  styleUrl: './donor-crm-info.component.scss',
})
export class DonorCrmInfoComponent {
  public isNgoAdmin: boolean = this.localStorageService.getIsNgoAdmin();
  public inviteDonatePopup: boolean = false;
  public ngoId: string = null;
  public donorId: string = null;
  public receiptObject: ReceiptModel = new ReceiptModel();
  public sessionUser = this.localStorageService.getSessionUser();
  // public showPaging: boolean = false;

  public donorsList: any = [];

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly sharedService: CommonSharedServiceService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly donorCrmService: DonorCrmService,
    private readonly utilitiesService: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.sharedService.updateReceiptPopupState(false);
    this.route.queryParams.subscribe((params) => {
      const encryptedString = params['data'];
      const decryptedParams =
        this.localStorageService.decryptObjectUrl(encryptedString);
      if (decryptedParams) {
        this.ngoId = decryptedParams.ngoId;
        this.donorId = decryptedParams.donorId;
        if (this.donorId) {
          this.getProfile();
        }
      } else {
        this.router.navigateByUrl('/');
        console.error('Decryption failed');
      }
    });
  }

  private getProfile() {
    this.donorCrmService
      .getDonorCrmProfile(this.ngoId, this.donorId)
      .subscribe({
        next: (result) => {
          this.donorsList = result;
          this.donorsList.profile_img = this.utilitiesService.jsonParse(
            this.donorsList?.profile_img
          );
          this.donorsList.team_info = result.team_info.map((team) => {
            const logo = this.utilitiesService.jsonParse(team.team_logo);
            return {
              text: team.team_name,
              icon: logo?.url,
            };
          });
        },
      });
  }
  public showReceiptPopup(receipt: any): void {
    this.receiptObject = new ReceiptModel();
    this.sharedService.updateReceiptPopupState(true);
    this.receiptObject.firstColumnName = 'Campaign';
    this.receiptObject.secondColumnName = 'NGOs Name';
    this.receiptObject.thirdColumnName = 'Donated Amount + Transaction Fee';
    this.receiptObject.secondColumnValue = receipt.ngo_name;
    this.receiptObject.thirdColumnValue = Number(
      +receipt.amount + +receipt.transaction_fees
    );
    this.receiptObject.total_amount = Number(
      +receipt.amount + +receipt.transaction_fees
    );
    this.receiptObject.invoice_no = String(
      Math.floor(Math.random() * (10000 - 200 + 1)) + 200
    );
    this.receiptObject.invoice_to = receipt.name;
    this.receiptObject.invoice_date = new Date();
    this.receiptObject.payment_method = 'Card';
    this.receiptObject.firstColumnValue = receipt.campaign_title;
  }

  public closeCreateEmailPopup() {
    this.inviteDonatePopup = false;
  }

  public inviteDonatePopUpOpen() {
    this.inviteDonatePopup = true;
  }

  // public setShowPaging(row: any) {
  //   this.showPaging = row?.data?.donation_type === 'DONATED';
  // }
}
